var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawFitnessStats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 619,
    height: 471.10966,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fitness_stats") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#e6e6e6",
    d: "m412.65582,424.52761l46.45777,-69.08737l-46.36275,76.51984l0.09695,7.77406q-5.08741,0.03879 -10.076,-0.16943l2.3042,-99.93046l-0.06313,-0.77093l0.085,-0.149l0.22054,-9.44283l-50.87674,-73.8671l50.81671,66.79969l0.18034,1.99592l1.74041,-75.50137l-43.9438,-76.58326l44.06895,63.31984l-0.46,-156.41937l0.001,-0.52062l0.015,0.512l2.91713,123.2796l40.04952,-50.07621l-39.91841,60.69646l0.87411,67.53422l36.85379,-65.91084l-36.71835,75.83953l0.48658,37.55243l53.59536,-91.813l-53.43243,104.91341l1.08825,83.50479z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#e6e6e6",
    d: "m569.0055,426.70374l46.45777,-69.08736l-46.36276,76.51983l0.09695,7.77406q-5.0874,0.03879 -10.076,-0.16943l2.3042,-99.93046l-0.06313,-0.77093l0.085,-0.149l0.22054,-9.44282l-50.87674,-73.86711l50.81671,66.79969l0.18033,1.99592l1.74045,-75.50131l-43.94379,-76.58326l44.06894,63.31984l-0.46,-156.41937l0.001,-0.52062l0.01495,0.512l2.91709,123.27952l40.04952,-50.07621l-39.9184,60.69646l0.8741,67.53422l36.85379,-65.91084l-36.71834,75.83953l0.48658,37.55243l53.59536,-91.813l-53.43241,104.91344l1.08829,83.50478z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.99998,
    stroke: "null",
    id: "svg_15",
    fill: "#3f3d56",
    height: 2,
    width: 611.00002,
    y: 439.74025
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "#9f616a",
    d: "m234.98787,146.9074s-6.28548,-46.0935 -16.76127,-33.52254s0,31.42738 0,31.42738l8.38063,10.47579l8.38064,-6.28547l0,-2.09516z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "#3f51b5",
    d: "m260.12982,161.57351s-20.95158,-23.04675 -25.1419,-18.85643s-16.76127,6.28548 -14.66611,14.66611s46.09349,35.6177 46.09349,35.6177l-6.28548,-31.42738z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    opacity: 0.1,
    d: "m260.12982,161.57351s-20.95158,-23.04675 -25.1419,-18.85643s-16.76127,6.28548 -14.66611,14.66611s46.09349,35.6177 46.09349,35.6177l-6.28548,-31.42738z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    fill: "#9f616a",
    d: "m379.55382,159.47835l0,16.76127s2.09516,37.71286 -10.47579,35.6177s-6.28548,-33.5225 -6.28548,-33.5225l2.09516,-18.85643l14.66611,-0.00004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    fill: "#9f616a",
    d: "m373.26835,280.99756s18.85647,29.33226 25.1419,31.42738s39.808,20.95159 43.99834,39.808l29.33223,37.71288l-14.66611,18.85643s-67.04508,-71.2354 -85.90151,-77.52088s-37.71286,-37.71286 -37.71286,-37.71286l39.80801,-12.57095z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    fill: "#9f616a",
    d: "m224.51207,232.80891s-39.808,6.28547 -33.52254,31.42738s67.04508,77.52088 67.04508,77.52088l2.09521,12.57095l23.04675,4.19032l10.47579,-10.4758l-2.09515,-6.28547s-25.14196,-23.04675 -27.23712,-31.42735s-25.1419,-41.90317 -35.6177,-43.99833l14.66611,-8.38064l-18.85643,-25.14194z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    fill: "#2f2e41",
    d: "m465.45534,389.94582s-8.38064,-12.57095 4.19031,-10.4758s20.95159,4.19032 20.95159,12.571s-10.47579,67.04508 -23.04675,62.85476s-2.09515,-23.04675 -2.09515,-23.04675s-6.28548,-16.76127 -10.4758,-18.85643s-4.19032,-12.57095 0,-12.57095s12.57095,-6.28551 10.4758,-10.47583z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    fill: "#2f2e41",
    d: "m287.36682,343.85232s0,-10.47579 8.38063,0s12.571,18.85643 4.19032,25.14191s-37.71284,20.95159 -37.71284,20.95159s-31.42738,6.28547 -27.23706,-8.38064c0,0 20.95159,-10.47579 20.95159,-18.85643s0,-23.04674 6.28547,-18.85643s25.14189,6.2855 25.14189,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_24",
    fill: "#2f2e41",
    d: "m327.17482,186.71541s29.33223,4.19032 27.23707,46.0935c0,0 37.71286,37.71286 27.23706,50.28381s-33.52254,35.6177 -41.90317,29.33222s-33.52251,-54.47412 -33.52251,-54.47412s-58.66445,20.95159 -69.14024,10.4758s-20.95159,-35.6177 -20.95159,-35.6177l52.379,-27.23707l58.66438,-18.85644z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_25",
    fill: "#9f616a",
    r: 25.14191,
    cy: 42.14947,
    cx: 245.46366
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_26",
    fill: "#9f616a",
    d: "m264.32009,44.24462s14.66611,23.04674 18.85643,25.1419s-29.33222,23.04675 -29.33222,23.04675s0,-27.23707 -10.4758,-33.52254l20.95159,-14.66611z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_27",
    fill: "#3f51b5",
    d: "m266.41525,67.29136s33.52254,-10.47579 39.808,6.28548s20.95157,48.18865 18.85645,69.14024s-6.28548,16.76127 0,23.04675s10.47579,2.09516 8.38063,10.47579s-4.19032,8.38064 -2.09516,12.57095s-25.1419,18.85643 -48.18865,20.95159l-23.0467,2.09516s0,-37.71286 -4.19031,-46.09349s-12.571,-25.14191 -12.571,-31.42739l0,-16.63084a63.6067,63.6067 0 0 1 8.38063,-31.55779l0,0s12.57095,-18.85645 14.66611,-18.85645z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_28",
    fill: "#3f51b5",
    d: "m291.55716,75.672s77.52087,6.28547 85.90151,27.23706s12.57095,62.85476 4.19031,62.85476s-18.85643,4.19031 -20.95158,0s-10.4758,-46.0935 -12.571,-46.0935s-64.94988,-6.2855 -64.94988,-6.2855s-27.23706,-33.5225 8.38064,-37.71282z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_29",
    fill: "#2f2e41",
    d: "m244.45348,35.91645s-6.67194,-11.59461 -15.01174,-1.52364s-21.907,-8.43622 -19.82426,-12.38526s9.4377,0.17757 22.04213,-3.94283s36.88462,-12.51446 40.951,14.86728s-5.61826,24.51117 -5.61826,24.51117s-4.43915,-24.26318 -8.45126,-17.29375l-4.01211,6.96943l-3.48019,0.85654l-6.59531,-12.05894z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawFitnessStats);
export default __webpack_public_path__ + "static/media/undraw_fitness_stats.048d06a16f984583c6a3cda979f57b9c.svg";
export { ForwardRef as ReactComponent };